import { useEffect, useRef } from "react";
import styled from "./style.module.css";

const VideoLoop = ({ videoLoop = {} }) => {
const videoRef = useRef();
const entityIDdiv= "loop"+videoLoop?.entityId
  const installPlayerScript = () => {
    const jwPlayerScript = document.createElement("script");
    jwPlayerScript.id = "jwPlayerLibrary";
    jwPlayerScript.src = process.env.NEXT_PUBLIC_LOOP_JWPLAYER_ID
    jwPlayerScript.async = true;
    jwPlayerScript.onload = () => {
      document.dispatchEvent(new CustomEvent('jwPlayerScriptLoaded'));
      initialize();
    };
    document.body.appendChild(jwPlayerScript);
  };


  const initialize = () => {
    window.removeEventListener("load", initialize);
    const player = window.jwplayer(videoRef.current);
    
    const playerOpts = {
      ...(videoLoop.url 
          ? { file: `https://cdn.jwplayer.com/v2/media/${videoLoop.entityId}/poster.mp4?width=320`, image: `https://cdn.jwplayer.com/v2/media/${videoLoop.entityId}/poster.jpg?width=320`, preload: "metadata" }
          : { playlist: `https://cdn.jwplayer.com/v2/media/${videoLoop.entityId}` })
    };

    if (videoRef.current) {
      player.setup(playerOpts);     
    }
  };

  useEffect(() => {
    const existingLibraryScript = document.getElementById("jwPlayerLibrary");
    if (!existingLibraryScript) {
      installPlayerScript();
    } else if (window?.jwplayer) {
      initialize();
    } else {
      document.addEventListener('jwPlayerScriptLoaded', initialize, { once: true });
    }    
  }, []);

  if(!entityIDdiv){
    return false;
  }
 
  return (
    <div className={styled['container-loop']}> 
        <div className={styled['video']} id={entityIDdiv} ref={videoRef} />
    </div>
  );
};

export default VideoLoop;